import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { selectCls } from "@/lib/inventory";
import { fmtDate } from "@/lib/workOrders";

export function NewToteDialog({ woId, onClose, onDone }: { woId?: string; onClose: () => void; onDone: () => void }) {
  const [wos, setWos] = useState<any[]>([]);
  const [wo, setWo] = useState(woId || "");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!woId) api.get("/work-orders").then((r) => { const list = r.data.filter((w: any) => !["cancelled", "completed"].includes(w.status)).sort((a: any, b: any) => (a.scheduled_date || "9").localeCompare(b.scheduled_date || "9")); setWos(list); if (!wo && list[0]) setWo(list[0].id); }).catch((e) => toast.error(errMsg(e))); }, [woId]); // eslint-disable-line react-hooks/exhaustive-deps
  const submit = async () => {
    setBusy(true);
    try { await api.post("/inventory/totes", { wo_id: wo, name }); toast.success("Job tote created"); onDone(); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="new-tote-dialog">
        <DialogHeader><DialogTitle>New job tote / bin</DialogTitle><DialogDescription>A tote is an inventory location tied to one work order. Transfer materials into it from the warehouse or truck.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          {!woId && <div><Label className="text-xs">Work order</Label><select data-testid="new-tote-wo" className={`${selectCls} mt-1`} value={wo} onChange={(e) => setWo(e.target.value)}>{wos.map((w) => <option key={w.id} value={w.id}>{w.homeowner?.name || "Job"} · {w.type_label} · {fmtDate(w.scheduled_date)}</option>)}</select></div>}
          <div><Label className="text-xs">Tote name (optional)</Label><Input data-testid="new-tote-name" className="mt-1 h-8" placeholder="e.g. Tote A, Bin 3 — auto-named if blank" value={name} onChange={(e) => setName(e.target.value)} /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2"><Button size="sm" variant="outline" data-testid="new-tote-cancel" disabled={busy} onClick={onClose}>Cancel</Button><Button size="sm" className="bg-blue-700 hover:bg-blue-800" data-testid="new-tote-save" disabled={busy || !wo} onClick={submit}>{busy ? "Creating…" : "Create tote"}</Button></div>
      </DialogContent>
    </Dialog>
  );
}
